// src/client/hooks/useSpeechSynthesis.js
import { useState, useCallback } from 'react';

export function useSpeechSynthesis() {
  const [isAtlasSpeaking, setIsAtlasSpeaking] = useState(false);

  const playTTS = useCallback((text) => {
    if (text.startsWith('*') && text.endsWith('*')) return; 

    if ('speechSynthesis' in window) {
      window.speechSynthesis.cancel();
      const utterance = new SpeechSynthesisUtterance(text);
      
      utterance.rate = 1.0;
      utterance.pitch = 1.0;
      
      // Track speaking state for UI animations
      utterance.onstart = () => setIsAtlasSpeaking(true);
      utterance.onend = () => setIsAtlasSpeaking(false);
      utterance.onerror = () => setIsAtlasSpeaking(false);

      window.speechSynthesis.speak(utterance);
    }
  }, []);

  return { playTTS, isAtlasSpeaking };
}